import { getConfig } from "./root.selectors";
import { RootState } from "./root.reducer";
import { GroupDefaults } from "../api/ssm/appConfigService.types";

export const isScheduleReportAvailable = (state: RootState) =>
  getConfig(state).showScheduledReports;

export const getSecureBlocksLimit = (state: RootState) =>
  getConfig(state).secureBlocksLimit;

export const getShowDrilldownPeriod = (state: RootState) =>
  getConfig(state).showDrilldownPeriod;

export const getShowEulaHeader = (state: RootState) =>
  getConfig(state).showEulaHeader;

export const getShowEulaFooter = (state: RootState) =>
  getConfig(state).showEulaFooter;

export const getBackendUrl = (state: RootState) => getConfig(state).backendUrl;

export const getShowEulaDialog = (state: RootState) =>
  getConfig(state).showEulaDialog;

export const getEulaCancelStrategy = (state: RootState) =>
  getConfig(state).eulaCancelStrategy;

export const getEulaCancelRedirectUrl = (state: RootState) =>
  getConfig(state).eulaCancelRedirectUrl;

const getConfigSecurity = (state: RootState) => getConfig(state).security;

export const getLogoutUrl = (state: RootState) =>
  getConfigSecurity(state).logoutUrl;

export const getNoLoginPage = (state: RootState) =>
  getConfigSecurity(state).noLoginPage;

export const getGoBackOnLoginErrorLink = (state: RootState) =>
  getConfigSecurity(state).goBackOnLoginErrorLink;

export const getGoBackOnLoginErrorLinkText = (state: RootState) =>
  getConfigSecurity(state).goBackOnLoginErrorLinkText;

export const getFirstDayOfWeek = (state: RootState) =>
  getConfig(state).firstDayOfWeek;

export const getAppTitle = (state: RootState) => getConfig(state).appTitle;

export const getDefaultLanguage = (state: RootState): string =>
  getConfig(state).defaultLanguage;

export const getUseFallbackLanguage = (state: RootState): boolean =>
  getConfig(state).useFallbackLanguage;

export const getSessionExpirationURL = (state: RootState): string =>
  getConfig(state).sessionExpiryURL;

export const getGroupDefaults = (state: RootState): GroupDefaults =>
  getConfig(state).groupDefaults;

export const getShowErrorPageBeforeAutoLogout = (state: RootState): boolean =>
  getConfig(state).showErrorPageBeforeAutoLogout;

export const getLogoLink = (state: RootState): string =>
  getConfig(state).logoLink;

export const getCustomLinkRef = (state: RootState): string =>
  getConfig(state).customLinkRef;
